import { useState, useEffect, Fragment } from "react";
import {
    StyleSheet, View, Text
} from "react-native";

import { FONT } from "../../../value/staticValues";
import { PLATFORM_URL } from "../../../value/Url";
import { requests } from "../../../common/RestAPI";

import { CustomTextInput, TextArea } from "../../base/CustomInputText";
import { CustomDropDown, DropdownType } from "../../base/CustomDropdown";
import CustomRadioBtn from "../../base/CustomRadioBtn";

import { ReactComponent as MsgInfoImg } from '../../../img/ico-msg-info-2.svg';

import { useTranslation } from "react-i18next";
import { CustomCircleCheckBox } from "../../base/CustomCheckBox";
import CustomText from "components/base/CustomText";
import { checkFormatAllow } from "common/util";
import { ProductTypeDropdownItem } from "./ProductData";


interface ArgsType {
    product_id: string;
    product_name: string;
    product_description: string | undefined;
    product_type_code: string;
    base_price: number;
}

interface ProductUpdateProps {
    showMessageCb?: Function,
    showLoadingCb?: Function,
    showSlideModalCb?: Function,
    stepIndex: number,
    clickedConfirmYn: boolean,
    resultCb?: Function,
    stepCount: number,
    args?: ArgsType
};

ProductUpdate.defaultProps = {
    stepIndex: 0,
    clickedConfirmYn: false,
    stepCount: 1,
}

export default function ProductUpdate(props:ProductUpdateProps) {
    const { t } = useTranslation();

    const [stepIndex, setStepIndex] = useState(0);
    const [executeUpdateYn, setExecuteUpdateYn] = useState(false);
    
    const [productName, setProductName] = useState(props.args?.product_name || "");
    const [productDesc, setProductDesc] = useState(props.args?.product_description || "");
    const [basePrice, setBasePrice] = useState(props.args?.base_price + "" || "0");
    
    const [productNameWarnYn, setProductNameWarnYn] = useState(false);
    const [basePriceWarnYn, setBasePriceWarnYn] = useState(false);
    
    useEffect(() => {
        if(props.showMessageCb) {
            props.showMessageCb("");
        }
        setStepIndex(props.stepIndex);
    }, [props.stepIndex]);


    useEffect(() => {
        if(props.clickedConfirmYn === true) {
            if(stepIndex < props.stepCount - 1) {
                if(stepIndex === 0) {
                    
                }
            } else {
                const successYn = checkProductData();
                if(successYn) {
                    setExecuteUpdateYn(true);
                } else {
                    executeResult({successYn: false}, false, '');;
                }
            }
            
        }
    }, [props.clickedConfirmYn]);


    useEffect(() => {
        if(executeUpdateYn) {
            executeUpdateProduct();
        }
    }, [executeUpdateYn]);


    function checkProductData() {
        if(props.showMessageCb) {
            props.showMessageCb("");
        }
        
        setProductNameWarnYn(false);
        setBasePriceWarnYn(false);

        let message = "";
        let error = false;
        if(!productName || !basePrice) {
            message = t("MESSAGE_SERVICE_PRODCUT_INFO_ENTER_ERROR_MESSAGE")
            if(!productName) {
                setProductNameWarnYn(true);    
            }
            if(!basePrice) {
                setBasePriceWarnYn(true);
            }
            error = true;
        }
        
        if(checkFormatAllow(basePrice, ["number"]) === false || Number(basePrice) < 0) {
            message = t("MESSAGE_SERVICE_PRODCUT_INFO_ENTER_ERROR_MESSAGE")
            setBasePriceWarnYn(true);    
            error = true;
        }

        if(error === true) {
            executeResult({}, false, message);
        }
        
        return !error;
    }

    function executeResult(result, closeYn, infoMessage) {
        setExecuteUpdateYn(false);
        if(props.showMessageCb && infoMessage) {
            props.showMessageCb(infoMessage);
        }
        if(props.resultCb) {
            props.resultCb(result, closeYn);
        }
    }
    function executeUpdateProduct() {
        const updatePackageData = {
            product: {
                product_name: productName,
                product_description: productDesc,
                base_price: Number(basePrice)
            }
        }
        
        requests.put(PLATFORM_URL.PRODUCT + "/" + props.args?.product_id, updatePackageData)
        .then((response) => {
            if(response.status === 200) {
                executeResult({successYn: true }, true, "");
            } else if(response.status === 409) {
                executeResult({successYn: false}, false, t("MESSAGE_SERVICE_PRODUCT_ADD_DUPLICATED_ERROR_MESSAGE"));
            } else {
                executeResult({successYn: false}, false, t("MESSAGE_CANNOT_COMMIT_DATA_MESSAGE"));
            }
            
        })
        .catch((error) => {
            if(error.status === 409) {
                executeResult({successYn: false}, false, t("MESSAGE_SERVICE_PRODUCT_ADD_DUPLICATED_ERROR_MESSAGE"));
            } else {
                executeResult({successYn: false}, false, t("MESSAGE_CANNOT_COMMIT_DATA_MESSAGE"));
            }
        });
    }
    

    return (
        <View>
            {
                stepIndex === 0 ?
                <View>
                    <View style={style.infoBoxContainer}>
                        <MsgInfoImg/>
                        <Text style={style.infoBoxContainerText}>
                            {t("SERVICE_PRODUCT_UPDATE_INFO_MESSAGE")}
                        </Text>
                    </View>
                    <Text style={style.titleText}>{
                        t("BASE_INFO_TEXT")}
                    </Text>
                    <View style={style.mainContainer}>
                        <View style={style.rowContainer}>
                            <CustomText text={t("SERVICE_PRODUCT_NAME_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomTextInput 
                                key={2} 
                                width={570} height={36} 
                                value={productName} 
                                type={"text"} 
                                activeYn={true} 
                                inputCb={setProductName} 
                                warnYn={productNameWarnYn} 
                                placeHolderText={t("NAME_ENTER_MESSAGE")}
                            />
                        </View>
                        <View style={style.rowTopAlignContainer}>
                            <Text style={style.columnText}>
                                {t("DESCRIPTION_TEXT")}
                            </Text>
                            <TextArea 
                                key={3} 
                                width={570} 
                                height={100} 
                                value={productDesc} 
                                type={"text"} 
                                activeYn={true}
                                inputCb={setProductDesc} 
                                warnYn={false} 
                                placeHolderText={t("DESCRIPTION_ENTER_MESSAGE")}
                            />
                        </View>
                        <View style={style.rowContainer}>
                            <CustomText text={t("SERVICE_PRODUCT_PRICE_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomTextInput 
                                key={22} 
                                width={110} height={36} 
                                value={basePrice} 
                                type={"number"} 
                                activeYn={true} 
                                inputCb={setBasePrice} 
                                warnYn={basePriceWarnYn} 
                                placeHolderText={"0"}
                            />
                        </View>
                        <Text style={{...style.rowDescribeContainer, marginBottom: 20}}>
                            {t("DESCRIBE_SERVICE_PRODUCT_PRICE_SELECT")}
                        </Text>
                    </View>
                </View>
                : null
            }
        </View>
    )
}


const style = StyleSheet.create({
    titleText: {
        marginTop: 40,
        fontFamily: FONT.MEDIUM,
        fontSize: 14,
        fontWeight: "500",
        color: "#0853fb",

    },
    mainContainer: {
        marginTop: 38
    },
    rowContainer: {
        height: 36,
        flexDirection: "row",
        marginBottom: 30,
        alignItems: "center"
    },
    rowTopAlignContainer: {
        minHeight: 36,
        flexDirection: "row",
        marginBottom: 30,
    },
    rowDivContainer: {
        borderStyle: "solid",
        borderBottomWidth: 1,
        borderBottomColor: "#eee",
        marginBottom: 30,
    },
    rowDescribeContainer: {
        marginLeft: 150, marginTop: -10, marginBottom: 40,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        lineHeight: 12,
        color: "#8c8c8c"
    },
    columnText: {
        width: 150,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        color: "#333",
    },
    infoBoxContainer: {
        flexDirection: "row", alignItems: "center",
        width: 700, height: 58,
        paddingLeft: 10, paddingRight: 10,
        marginBottom: 15,
        borderRadius: 2,
        backgroundColor: "#fafafa"
    },
    infoBoxContainerText: {
        marginLeft: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        lineHeight: 18,
        color: "#9ea0a5"
    },
});


const labelStyle = {
    fontFamily: FONT.REGULAR,
    fontSize: 12,
    color: "#333"
}